<template>
  <div class="home">
    <Recipes msg="Most Recent" v-if="recipesLoaded"></Recipes>
    <div v-else>Loading Recipes...</div>
  </div>
</template>

<script>
// @ is an alias to /src
import Recipes from "@/components/Recipes.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        Recipes
    },
    computed: {
        ...mapGetters(["recipesLoaded"])
    }
};
</script>
